
import common from './zh_TW/common'
import areaCode from './zh_TW/areaCode'
import communicateCenter from './zh_TW/communicateCenter'
import components from './zh_TW/components'
import course from './zh_TW/course'
import courseDetail from './zh_TW/courseDetail'
import examDetail from './zh_TW/examDetail'
import home from './zh_TW/home'
import humanTraining from './zh_TW/humanTraining'
import inforList from './zh_TW/inforList'
import Information from './zh_TW/Information'
import intelligentOfficialDoc from './zh_TW/intelligentOfficialDoc'
import knowledgeLib from './zh_TW/knowledgeLib'
import LearnRecords from './zh_TW/LearnRecords'
import Login from './zh_TW/Login'
import myCourse from './zh_TW/myCourse'
import myExam from './zh_TW/myExam'
import mynews from './zh_TW/mynews'
import mySetting from './zh_TW/mySetting'
import mytopic from './zh_TW/mytopic'
import myTrainingClass from './zh_TW/myTrainingClass'
import myTrainingDetail from './zh_TW/myTrainingDetail'
import myWork from './zh_TW/myWork'
import post from './zh_TW/post'
import postDetail from './zh_TW/postDetail'
import practiceTrain from './zh_TW/practiceTrain'
import publicExam from './zh_TW/publicExam'
import questionnaire from './zh_TW/questionnaire'
import rules from './zh_TW/rules'
import search from './zh_TW/search'
import studyMap from './zh_TW/studyMap'
import topic from './zh_TW/topic'
import topicDetail from './zh_TW/topicDetail'
import topicManagerRange from './zh_TW/topicManagerRange'
import trainingClass from './zh_TW/trainingClass'
import trainingCourseDetail from './zh_TW/trainingCourseDetail'
import webLive from './zh_TW/webLive'

export default {
  ...common,
  ...areaCode,
  ...communicateCenter,
  ...components,
  ...course,
  ...courseDetail,
  ...examDetail,
  ...home,
  ...humanTraining,
  ...inforList,
  ...Information,
  ...intelligentOfficialDoc,
  ...knowledgeLib,
  ...LearnRecords,
  ...Login,
  ...myCourse,
  ...myExam,
  ...mynews,
  ...mySetting,
  ...mytopic,
  ...myTrainingClass,
  ...myTrainingDetail,
  ...myWork,
  ...post,
  ...postDetail,
  ...practiceTrain,
  ...publicExam,
  ...questionnaire,
  ...rules,
  ...search,
  ...studyMap,
  ...topic,
  ...topicDetail,
  ...topicManagerRange,
  ...trainingClass,
  ...trainingCourseDetail,
  ...webLive,
}
